import { useEffect, useState } from 'react';

const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const mobileRegex = /android|iphone|ipad|iPod/i;
        const detectedMobile = mobileRegex.test(userAgent);
        setIsMobile(detectedMobile);
    }, []); // Runs only once after the initial render

    return isMobile;
};

export default useIsMobile;
